import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiCheckCircle } from 'react-icons/fi';

const CreatorBundle = () => {
  return (
    <section id="bundles" className="py-32 px-6">
      <div className="max-w-7xl mx-auto glass-panel rounded-[2.5rem] overflow-hidden relative group">
        <div className="absolute top-0 right-0 w-full lg:w-1/2 h-full z-0 overflow-hidden">
          <img 
            src="https://images.unsplash.com/photo-1605810230434-7631ac76ec81?w=1200&q=80" 
            alt="Bundle"
            className="w-full h-full object-cover opacity-30 grayscale mix-blend-screen transition-transform duration-[2s] group-hover:scale-110"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-zinc-900 via-zinc-900/80 to-transparent" />
        </div>

        <div className="relative z-10 p-10 lg:p-20 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-block px-4 py-1 rounded-full bg-cyan-400 text-black text-[9px] font-black uppercase tracking-[0.3em] mb-8">
              Bundle Exclusive
            </div>
            
            <h2 className="text-5xl lg:text-7xl font-black uppercase tracking-tighter leading-[0.9] mb-8">
              The <span className="text-cyan-400">Creator</span> <br />Arsenal
            </h2>
            
            <p className="text-zinc-400 text-sm leading-relaxed mb-10 max-w-md">
              A comprehensive mobile kit designed for street photographers and content creators. High-tensile strength materials meet high-art aesthetics.
            </p>

            <div className="space-y-4 mb-12">
              {[
                '1x Cyber Flora Series Case',
                '1x Structural Holo Grip',
                '1x Reflective Tech Lanyard',
                'Priority Drop 002 Access'
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-4 group/item">
                  <SafeIcon icon={FiCheckCircle} className="text-cyan-400 group-hover/item:scale-125 transition-transform" />
                  <span className="text-xs font-bold uppercase tracking-widest text-zinc-300">{item}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-8">
              <button className="w-full sm:w-auto px-10 py-5 bg-white text-black font-black uppercase tracking-widest text-[11px] hover:bg-cyan-400 transition-colors">
                Acquire Bundle — $85.00
              </button>
              <div className="flex flex-col">
                <span className="text-[10px] font-black text-zinc-500 uppercase tracking-widest line-through">$111.00</span>
                <span className="text-xs font-black text-fuchsia-500 uppercase tracking-widest">Saving $26.00</span>
              </div>
            </div>
          </div>
          
          <div className="hidden lg:block relative aspect-square">
            <div className="absolute inset-0 border border-white/10 rounded-full animate-[spin_20s_linear_infinite]" />
            <div className="absolute inset-10 border border-cyan-400/20 rounded-full animate-[spin_15s_linear_infinite_reverse]" />
            <div className="absolute inset-0 flex items-center justify-center">
               <div className="text-center">
                  <p className="text-6xl font-black italic text-white/10">001</p>
                  <p className="text-[10px] font-black uppercase tracking-[1em] text-white/5">ARSENAL</p>
               </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CreatorBundle;